import { Component } from "@angular/core"
import { AlertController } from "ionic-angular"

import firebase from "firebase"

import { AppEnv } from "./app.env"
import { LoadingPage } from "../pages/loading"
import { AppTabPages } from "../pages/tabs"
import { LoginPage } from "../pages/login"
import { WelcomePage } from "../pages/welcome"
import { AppLocalStorage } from "../services/app-local-storage"

@Component({
  templateUrl: "app.html"
})
export class App {

  rootPage:any = LoadingPage

  constructor(
    private alertCtrl: AlertController
  ) {

    firebase.initializeApp(AppEnv.firebaseConfig)

    firebase.auth().onAuthStateChanged((user) => {

      if (user) {
        this.rootPage = AppLocalStorage.get("viewedSlides") ? AppTabPages : WelcomePage
      } else {
        this.rootPage = LoginPage
      }
    })

    if (AppEnv.isStaging) {
      this.alertCtrl.create({
        title: "Atenção",
        message: "Você está usando o ambiente de testes",
        buttons: ["Ok"]
      }).present()
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/app.component.ts